import SidebarItem from "./SidebarItem";

const Sidebar = ({ categories, onCategorySelect, selectedCategoryId, selectedSubCategoryId }) => {
  if (!categories || categories.length === 0) return <div>No Categories</div>;

  return (
    <div className="list-group d-none d-md-block">
      <SidebarItem
        nodes={categories}
        eventKeyPrefix=""
        onSelect={onCategorySelect}
        selectedCategoryId={selectedCategoryId}
        selectedSubCategoryId={selectedSubCategoryId}
      />
    </div>
  );
};

export default Sidebar;